"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerImportExecuteResponse = exports.CustomerImportExecuteResult = exports.CustomerImportExecuteOutcome = exports.CustomerImportExecuteOutcomes = exports.CustomerImportExecuteRequest = exports.CustomerImportPreviewResponse = exports.CustomerImportPreviewRequest = exports.CustomerImportCandidate = exports.CustomerImportCandidateCustomer = exports.CustomerImportCandidateStatus = exports.CustomerImportCandidateStatuses = exports.CustomerImportIssue = exports.CustomerImportIssueSeverity = exports.CustomerImportIssueSeverities = exports.CustomerImportTemplateColumn = exports.CustomerImportTemplateColumns = void 0;
const typebox_1 = require("@sinclair/typebox");
const address_transport_1 = require("./address-transport");
const base_customer_contact_1 = require("./base-customer-contact");
exports.CustomerImportTemplateColumns = [
    'Company Name',
    'First Name',
    'Last Name',
    'Email Address',
    'Phone',
    'Billing Street Address',
    'Billing City',
    'Billing State',
    'Billing Zip Code',
    'Notes',
];
exports.CustomerImportTemplateColumn = typebox_1.Type.Union(exports.CustomerImportTemplateColumns.map((column) => typebox_1.Type.Literal(column)));
exports.CustomerImportIssueSeverities = ['error', 'warning'];
exports.CustomerImportIssueSeverity = typebox_1.Type.Union(exports.CustomerImportIssueSeverities.map((severity) => typebox_1.Type.Literal(severity)));
exports.CustomerImportIssue = typebox_1.Type.Object({
    code: typebox_1.Type.String(),
    severity: exports.CustomerImportIssueSeverity,
    message: typebox_1.Type.String(),
    column: typebox_1.Type.Optional(exports.CustomerImportTemplateColumn),
    sourceRow: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1 })),
});
exports.CustomerImportCandidateStatuses = [
    'ready',
    'warning',
    'error',
    'exists',
    'review',
    'add-contacts',
];
exports.CustomerImportCandidateStatus = typebox_1.Type.Union(exports.CustomerImportCandidateStatuses.map((status) => typebox_1.Type.Literal(status)));
exports.CustomerImportCandidateCustomer = typebox_1.Type.Object({
    companyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    billingAddress: address_transport_1.AddressTransport,
    contacts: typebox_1.Type.Array(base_customer_contact_1.BaseCustomerContactCreate),
});
exports.CustomerImportCandidate = typebox_1.Type.Object({
    key: typebox_1.Type.String(),
    sourceRows: typebox_1.Type.Array(typebox_1.Type.Integer({ minimum: 1 })),
    status: exports.CustomerImportCandidateStatus,
    customer: exports.CustomerImportCandidateCustomer,
    issues: typebox_1.Type.Array(exports.CustomerImportIssue),
    matchingCustomerIDs: typebox_1.Type.Array(typebox_1.Type.String()),
    existingCustomerID: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.CustomerImportPreviewRequest = typebox_1.Type.Object({
    fileName: typebox_1.Type.String(),
    csv: typebox_1.Type.String(),
});
exports.CustomerImportPreviewResponse = typebox_1.Type.Object({
    rowCount: typebox_1.Type.Integer({ minimum: 0 }),
    fileIssues: typebox_1.Type.Array(exports.CustomerImportIssue),
    candidates: typebox_1.Type.Array(exports.CustomerImportCandidate),
});
exports.CustomerImportExecuteRequest = typebox_1.Type.Object({
    candidates: typebox_1.Type.Array(exports.CustomerImportCandidate, { maxItems: 100 }),
});
exports.CustomerImportExecuteOutcomes = [
    'created',
    'contacts-added',
    'skipped-existing',
    'skipped-ineligible',
    'failed',
];
exports.CustomerImportExecuteOutcome = typebox_1.Type.Union(exports.CustomerImportExecuteOutcomes.map((outcome) => typebox_1.Type.Literal(outcome)));
exports.CustomerImportExecuteResult = typebox_1.Type.Object({
    key: typebox_1.Type.String(),
    outcome: exports.CustomerImportExecuteOutcome,
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerNumber: typebox_1.Type.Optional(typebox_1.Type.Number()),
    error: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.CustomerImportExecuteResponse = typebox_1.Type.Object({
    results: typebox_1.Type.Array(exports.CustomerImportExecuteResult),
});
//# sourceMappingURL=customer-import-transport.js.map